const {
  createApi,
  fetchBaseQuery
} = RTKQ;
export const retailerApplicationApi = createApi({
  reducerPath: 'retailerApplicationApi',
  baseQuery: fetchBaseQuery({
    baseUrl: svs.welcome?.data?.retailerApplicationApi,
    credentials: 'include'
  }),
  endpoints: builder => ({
    addApplication: builder.mutation({
      query: formData => {
        const body = {
          sellTypeCompleteRetailer: Boolean(formData.sellTypeCompleteRetailer),
          sellTypeTickets: Boolean(formData.sellTypeTickets),
          companyName: formData.companyName,
          orgNumber: formData.orgNumber,
          signatoryName: formData.signatoryName,
          signatorySsn: formData.signatorySsn,
          signatoryMobilePhone: formData.signatoryMobilePhone,
          signatoryEmail: formData.signatoryEmail,
          storeName: formData.storeName,
          storeAddress: formData.storeAddress,
          storePostalCode: formData.storePostalCode,
          storeCity: formData.storeCity,
          storePhone: formData.storePhone,
          storeMobilePhone: formData.storeMobilePhone,
          storeEmail: formData.storeEmail,
          contactName: formData.contactName,
          contactMobilePhone: formData.contactMobilePhone,
          contactEmail: formData.contactEmail,
          customersPerWeek: Number(formData.customersPerWeek),
          turnoverMSek: Number(formData.turnoverMSek),
          manualRegisters: Number(formData.manualRegisters),
          hoursWeekdays: formData.hoursWeekdays || null,
          hoursSaturday: formData.hoursSaturday || null,
          hoursSunday: formData.hoursSunday || null,
          comment: formData.comment || null,
          consent: Boolean(formData.consent),
          deliveryAddress: formData.deliveryAddress || null,
          deliveryPostalCode: formData.deliveryPostalCode || null,
          deliveryCity: formData.deliveryCity || null,
          prospectChain: formData.prospectChain || null,
          inStoreRegisters: Number(formData.inStoreRegisters) || 0,
          reconciliationRegisters: Number(formData.reconciliationRegisters) || 0,
          selfCheckoutRegisters: Number(formData.selfCheckoutRegisters) || 0
        };
        return {
          url: `/v1/application`,
          method: 'POST',
          body
        };
      }
    })
  })
});